export const getVorTableData = (state) => state.vor.tableData;
export const getVorHeaderData = (state) => state.vor.headerData;
export const getVorFetchStatus = (state) => state.vor.fetchStatus;
export const getVorFetchStatusText = (state) => state.vor.fetchStatusText;
export const getVorConnectedLsrItemModalVisible = (state) => state.vor.connectedLsrItemModalVisible;
export const getVorConnectedLsrItemModalTableData = (state) => state.vor.connectedLsrItemModalTableData;
